import React from 'react'

// import barcode from "../../../assets/images/barcode.svg"

import "./section4.css"

const Section4 = () => {
    return (
        <section className='section4'>
            <h1 className='section4_heading'>
                There’s more, and<br />there’s more to come 😏
            </h1>
            <h1 className='section4_heading-small'>
                There’s more, and there’s <br />more to come 😏
            </h1>
            <div className='section4_tab-container'>
                <div className='section4_tabs'>
                    <h1>Tags for content</h1>
                </div>
                <div className='section4_tabs'>
                    <h1>Reminders</h1>
                </div>
                <div className='section4_tabs'>
                    <h1>In-App Reader</h1>
                </div>
                <div className='section4_tabs'>
                    <h1>Quick Search</h1>
                </div>
            </div>

            <div className='section4_tab-container2'>
                <div className='section4_tabs'>
                    <h1>Video Player</h1>
                </div>
                <div className='section4_tabs'>
                    <h1> Image Viewer</h1>
                </div>
                <div className='section4_tabs'>
                    <h1>Tweet Reader Mode</h1>
                </div>
                <div className='section4_tabs'>
                    <h1>More, Soon.</h1>
                </div>
            </div>


            <div className='section4_bottom'>
                <div className='section4_bottom-text'>
                    <p>Start using MyPipe App,<br /> and supercharge your<br /> experience.</p>
                </div>
                <div className='section4_bottom-text-small'>
                    <p>Use MyPipe App, and supercharge your experience.</p>
                </div>
                {/* <div className='section4_bottom-scan'>
                    <p>Scan  to download beta app.</p>
                    <img src={barcode} alt="Scan code" />
                </div> */}
                <div className='request_app'>
                    <p>Request Beta App</p>
                </div>
            </div>
        </section >
    )
}
export default Section4;